const itemDocumentsActions = {
  ITEM_DOCUMENTS_STATE_INIT: 'ITEM_DOCUMENTS_STATE_INIT',
  ITEM_DOCUMENTS_LIST_SET: 'ITEM_DOCUMENTS_LIST_SET'
};
export default itemDocumentsActions;
